import { createLanguageRegistrar } from "./languageBase";

/** Monarch language definition for GraphQL. */
const graphqlDef: Record<string, unknown> = {
  keywords: [
    "query",
    "mutation",
    "subscription",
    "fragment",
    "on",
    "type",
    "interface",
    "union",
    "enum",
    "scalar",
    "input",
    "extend",
    "implements",
    "directive",
    "schema",
  ],

  builtinTypes: ["String", "Int", "Float", "Boolean", "ID"],

  tokenizer: {
    root: [
      [/"""/, "string.gql", "@blockString"],
      [/#[^\n]*/, "comment.gql"],
      [/@[a-z_]\w*/i, "annotation.gql"],
      [/\$[a-z_]\w*/i, "variable.gql"],
      [/\.\.\./, "keyword.operator.gql"],
      [
        /[a-z_]\w*/i,
        {
          cases: {
            "@keywords": "keyword.gql",
            "@builtinTypes": "type.identifier.gql",
            true: "keyword.gql",
            false: "keyword.gql",
            null: "keyword.gql",
            "@default": "identifier",
          },
        },
      ],
      [/\d[\d.]*/, "number.gql"],
      [/"/, "string.gql", "@string"],
      [/[{}()[\]]/, "delimiter"],
      [/[:|=!&]/, "delimiter"],
      [/\s+/, "white"],
    ],

    string: [
      [/[^\\"]+/, "string.gql"],
      [/\\./, "string.escape.gql"],
      [/"/, "string.gql", "@pop"],
    ],

    blockString: [
      [/"""/, "string.gql", "@pop"],
      [/./, "string.gql"],
    ],
  },
};

/**
 * Registers a Monarch tokenizer for GraphQL with Monaco.
 * Monaco has no built-in GraphQL support, so this provides syntax highlighting
 * for `language="graphql"` on `<e-editor>`.
 */
export const registerGraphQL = createLanguageRegistrar({ id: "graphql", extensions: [".graphql", ".gql"] }, graphqlDef);
